<template>
	<div>
		<template v-if="type != 'show'">
			<v-form ref="addressInfo" v-model="ui.forms.addressInfo" lazy-validation>
				<v-row>
					<v-col cols="9">
						<v-text-field v-model="salesorder.delivery_address" outlined clearable
							label="Dirección de entrega"
							:rules="[v => !!v || 'El campo es obligatorio']"></v-text-field>
					</v-col>
					<v-col cols="3">
						<v-text-field v-model="salesorder.contac_phone" outlined clearable label="Número telefónico"
							:rules="[v => !!v || 'El campo es obligatorio', v.double, v => (v && v.length === 10) || 'El campo debe tener 10 digitos']"></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6">
						<v-text-field v-model="salesorder.freight" outlined clearable label="Fletera"
							:rules="[v => !!v || 'El campo es obligatorio']"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-text-field v-model="salesorder.contac_name" outlined clearable label="Nombre de contacto"
							:rules="[v => !!v || 'El campo es obligatorio']"></v-text-field>
					</v-col>

				</v-row>
			</v-form>

			<v-form ref="general" v-model="ui.forms.general" lazy-validation @submit.prevent="store()">
				<v-row justify="end">
					<v-col cols="12" :md="hasRol(1) ? 6 : 12" class="pb-0 d-flex" v-if="hasRol(1)">
						<v-overflow-btn flat darck outlined editable clearable label="Cliente" autocomplete="off"
							:items="Customers" :rules="[v.required]" background-color="#fff" @change="customerChanged()"
							v-model="salesorder.customer_id" :disabled="ui.getingCustomers ||
								salesorder.articles.length > 0
								" :loading="$store.state.ui.getingCustomers"></v-overflow-btn>
					</v-col>

					<v-col cols="12" :md="hasRol(1) ? 6 : 12" class="pb-0 d-flex">
						<v-overflow-btn flat darck editable outlined clearable @change="save()" autocomplete="off"
							background-color="#fff" label="Método de envío" :items="ShippingMethods"
							:loading="getingShippingMethods" v-model="salesorder.shipping_method_id"
							:disabled="ui.getingShippingMethods"></v-overflow-btn>

						<v-tooltip top v-if="hasRol(1)">
							<template v-slot:activator="{ on, attrs }">
								<v-btn text fab small v-on="on" class="ml-2 mt-2" v-bind="attrs"
									@click="shippingMethodCreate()">
									<v-icon>mdi-plus-circle-outline</v-icon>
								</v-btn>
							</template>
							<span>Crear nuevo metodo de envío</span>
						</v-tooltip>
					</v-col>
				</v-row>
			</v-form>

			<v-form ref="layout" lazy-validation v-model="ui.forms.layout" @submit.prevent="save()"
				v-if="salesorder.customer_id">
				<v-row>
					<v-col cols="12" class="pb-0 pt-0">
						<v-overflow-btn flat darck attach editable outlined autofocus clearable :items="Articles"
							label="Artículo" v-model="layout" autocomplete="off" :rules="[v.required]"
							background-color="#fff" :loading="ui.articlesGeting" :disabled="this.ui.articlesGeting ||
								!this.salesorder.customer_id
								"></v-overflow-btn>
					</v-col>

					<template v-if="layout">
						<template v-if="layout.amount">
							<v-col cols="12" md="6" :class="[
								'pt-0',
								'pb-0',
								{ 'pb-7': $vuetify.breakpoint.smAndDown },
							]">
								<AmountIputGroup v-model="layout.amount" :min="ItemNewBoxCapacity" label="pieza"
									:interval="ItemNewBoxCapacity"></AmountIputGroup>
							</v-col>

							<v-col cols="12" md="3" class="pt-0 pb-0" v-if="hasRol(1)">
								<v-text-field outlined @change="save()" label="Descuento unitario(%)" autocomplete="off"
									v-model="layout.discount" :disabled="!salesorder.customer_id" :rules="[
										v.double,
										v.max('numeric', 100, layout.discount),
									]"></v-text-field>
							</v-col>

							<v-col cols="12" :md="hasRol(1) ? 3 : 6" class="pb-0 pt-0">
								<v-btn outlined color="primary" @click="articleAdd()" :disabled="!ui.forms.layout" block
									height="55px">
									Agregar
								</v-btn>
							</v-col>
						</template>
					</template>
				</v-row>
			</v-form>
		</template>

		<template v-if="type == 'show'">
			<v-row>
				<v-col cols="12" md="4" class="d-flex flex-column pt-1 pb-1">
					<strong>
						Cliente:
					</strong>

					<template v-if="hasRol(1)">
						<router-link :to="{
							name: 'CustomerShow',
							params: { id: salesorder.customer_id },
						}">
							{{
								`${salesorder.customer.folio} - ${salesorder.customer.name}`
							}}
						</router-link>
					</template>

					<template v-else>
						{{
							`${salesorder.customer.folio} - ${salesorder.customer.name}`
						}}
					</template>
				</v-col>

				<v-col cols="12" md="4" class="d-flex flex-column pt-1 pb-1">
					<strong>
						Metodo de envío:
					</strong>

					<template v-if="salesorder.shipping_method">
						{{ salesorder.shipping_method.name }}
					</template>
				</v-col>

				<v-col cols="12" md="2" class="d-flex flex-column pt-1 pb-1">
					<strong>
						Creado:
					</strong>
					{{ salesorder.created_at_new }}
				</v-col>

				<v-col cols="12" md="2" class="d-flex flex-column pt-1 pb-1">
					<strong>
						Actualizado:
					</strong>
					{{ salesorder.updated_at_new }}
				</v-col>
				<v-col cols="12" md="4" class="d-flex flex-column pt-1 pb-1">
					<Strong>
						Dirección:
					</Strong>
					{{ salesorder.delivery_address }}
				</v-col>
				<v-col cols="12" md="4" class="d-flex flex-column pt-1 pb-1">
					<Strong>
						Fletera:
					</Strong>
					{{ salesorder.freight }}
				</v-col>
				<v-col cols="12" md="2" class="d-flex flex-column pt-1 pb-1">
					<Strong>
						Nombre de contacto:
					</Strong>
					{{ salesorder.contac_name }}
				</v-col>
				<v-col cols="12" md="2" class="d-flex flex-column pt-1 pb-1">
					<Strong>
						Telefono:
					</Strong>
					{{ salesorder.contac_phone }}
				</v-col>
			</v-row>
		</template>

		<v-row class="mt-5">
			<v-col cols="12" class="d-flex align-center justify-space-between pl-5 pr-5"
				style="background-color: rgba(0, 0, 0, .04);">
				<h3>
					Artículos agregados:
					<span class="black--text">
						{{ salesorder.articles.length }}
					</span>
				</h3>

				<div style="width: 250px;">
					<v-text-field dense outlined hide-details label="Buscar" clearable
						v-model="ui.search"></v-text-field>
				</div>
			</v-col>

			<v-col cols="12" class="pa-0">
				<v-data-table key="id" disable-sort :search="ui.search" item-key="id" :headers="headers()"
					:show-expand="hasRol(1)" :items="salesorder.articles">
					<template v-if="hasRol(1)" v-slot:expanded-item="{ headers, item }">
						<td colspan="100" class="pa-0">
							<v-container style="background-color: #eee;">
								<v-row>
									<v-col cols="6" md="3">
										<span class="black--text mr-1">
											Precio base:
										</span>
										{{ priceFormat(item.base_price) }}
									</v-col>
									<v-col cols="6" md="3">
										<span class="black--text mr-1">
											Descuento base:
										</span>
										{{ `${item.base_discount}%` }}
									</v-col>
									<v-col cols="6" md="3">
										<span class="black--text mr-1">
											Precio preferente:
										</span>
										<template v-if="
											item.preferential_price !=
											undefined &&
											item.preferential_price !=
											null
										">
											{{
												priceFormat(
													item.preferential_price
												)
											}}
										</template>
									</v-col>
									<v-col cols="6" md="3">
										<span class="black--text mr-1">
											Descuento preferente:
										</span>
										<template v-if="
											item.preferential_discount !=
											undefined &&
											item.preferential_discount !=
											null
										">
											{{
												`${item.preferential_discount}%`
											}}
										</template>
									</v-col>
								</v-row>
							</v-container>
						</td>
					</template>

					<!-- Slot Key -->
					<!-- <template v-slot:item.index="{ item }">
						{{ getIndexOf(item.id) }}
					</template> -->

					<!-- Slot Article -->
					<template v-if="hasRol(1)" v-slot:item.code="{ item }">
						<router-link :to="{
							name: 'ArticleIndex',
							query: { criterium: item.code },
						}">
							{{ item.code }}
						</router-link>
					</template>

					<!-- Slot Importe -->
					<template v-slot:item.importe="{ item }">
						{{ priceFormat(getItemAmount(item)) }}
					</template>

					<!-- Slot BoxCapacity -->
					<template v-slot:item.box_capacity="{ item }">
						{{ getItemBoxCapacity(item) }}
					</template>

					<!-- Slot Precio -->
					<template v-slot:item.price="{ item }">
						<template v-if="hasRol(1)">
							<template v-if="['show'].includes(type)">
								{{ priceFormat(item.price) }}
							</template>

							<template v-else>
								<v-edit-dialog large persistent @save="save()" save-text="guardar"
									cancel-text="cancelar" :return-value.sync="item.price">
									<v-tooltip right>
										<template v-slot:activator="{ on, attrs }">
											<span v-bind="attrs" v-on="on">
												{{ priceFormat(item.price) }}
											</span>
										</template>
										<span>
											Modificar precio
										</span>
									</v-tooltip>

									<template v-slot:input>
										<v-container fluid>
											<v-row class="pb-0">
												<v-col cols="12" class="pt-0 pb-0">
													{{
														`Precio pra orden de venta, linea: ${getIndexOf(
															item
														)}:`
													}}
												</v-col>
												<v-col cols="12" class="pt-0 pb-0">
													<v-text-field min="0" max="100" outlined autofocus @change="
														min(
															item,
															'price',
															'precio',
															1,
															true
														)
														" class="mt-4" type="number" hide-details label="Precio" autocomplete="off"
														v-model="item.price"></v-text-field>
												</v-col>
											</v-row>
										</v-container>
									</template>
								</v-edit-dialog>
							</template>
						</template>

						<template v-else>
							{{ priceFormat(item.price) }}
						</template>
					</template>

					<!-- Slot Discount -->
					<template v-slot:item.discount="{ item }">
						<template v-if="!hasRol(1)">
							{{ `${item.discount}%` }}
						</template>

						<template v-else>
							<template v-if="type == 'show'">
								{{ `${item.discount}%` }}
							</template>

							<template v-else>
								<v-edit-dialog large @save="save()" save-text="guardar" cancel-text="cancelar"
									:return-value.sync="item.discount">
									<v-tooltip right>
										<template v-slot:activator="{ on, attrs }">
											<span v-bind="attrs" v-on="on">
												{{ `${item.discount}%` }}
											</span>
										</template>
										<span>
											Modificar descuento
										</span>
									</v-tooltip>

									<template v-slot:input>
										<v-container fluid>
											<v-row class="pb-0">
												<v-col cols="12" class="pt-0 pb-0">
													{{
														`Descuento pra orden de venta, linea: ${getIndexOf(
															item
														)}:`
													}}
												</v-col>
												<v-col cols="12" class="pt-0 pb-0">
													<v-text-field hide-details min="0" max="100" outlined autofocus
														@change="
															min(
																item,
																'discount',
																'descuento',
																0,
																true
															),
															max(
																item,
																'discount',
																'descuento',
																100,
																true
															)
															" class="mt-4" hide-details type="number" label="Descuento" autocomplete="off"
														v-model="item.discount"></v-text-field>
												</v-col>
											</v-row>
										</v-container>
									</template>
								</v-edit-dialog>
							</template>
						</template>
					</template>

					<!-- Slot Amount -->
					<template v-slot:item.amount="{ item }">
						<template v-if="type == 'show'">
							{{ item.amount }}
						</template>

						<template v-else>
							<v-edit-dialog large @save="save()" save-text="guardar" cancel-text="cancelar"
								:return-value.sync="item.amount">
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">
											{{ item.amount }}
										</span>
									</template>
									<span>
										Modificar cantidad
									</span>
								</v-tooltip>

								<template v-slot:input>
									<v-container fluid>
										<v-row class="pb-0">
											<v-col cols="12" class="pt-0">
												{{
													`Cantidad de la linea ${getIndexOf(
														item
													)}:`
												}}
											</v-col>
											<v-col cols="12" class="pb-0 pt-0">
												<AmountIputGroup label="pieza" v-model="item.amount"
													:min="getBoxCapacity(item)" :interval="getBoxCapacity(item)
														"></AmountIputGroup>
											</v-col>
										</v-row>
									</v-container>
								</template>
							</v-edit-dialog>
						</template>
					</template>

					<!-- Slot Actions -->
					<template v-slot:item.remove="{ item }">
						<template v-if="type === 'create' || type === 'edit'">
							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<v-btn fab x-small v-on="on" color="#eee" elevation="0" v-bind="attrs"
										@click="removeItem(item)">
										<v-icon>
											mdi-delete
										</v-icon>
									</v-btn>
								</template>
								<span>Remover linea</span>
							</v-tooltip>
						</template>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" v-if="['edit', 'create'].includes(type)">
				<v-textarea outlined :clearable="type == 'edit'" label="Nota(opcional)" :readonly="type == 'show'"
					:counter="ui.maxLengthNote" :rules="[v.max('text', ui.maxLengthNote, salesorder.note)]"
					@change="save()" v-model="salesorder.note"></v-textarea>
			</v-col>

			<v-col cols="12" class="d-flex flex-column" v-else>
				<strong>NOTA:</strong>
				<p class="black--text">{{ salesorder.note }}</p>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" md="8">
				<v-row>
					<v-col cols="3" md="2" class="pb-0 pt-1 d-flex justify-start font-weight-bold black--text">
						Peso total:
					</v-col>
					<v-col cols="9" md="10" class="pb-0 pt-1 d-flex justify-start black--text">
						<span>
							{{ Weight }}
						</span>
					</v-col>
				</v-row>
			</v-col>

			<v-col cols="12" md="4" class=" black--text">
				<v-row>
					<v-col cols="7" class="pb-0 pt-1 d-flex justify-end font-weight-bold">
						Subtotal:
					</v-col>
					<v-col cols="5" class="pb-0 pt-1 d-flex justify-end">
						{{ subtotal }}
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="7" class="pb-0 pt-1 d-flex justify-end font-weight-bold">
						<template v-if="hasRol(1)">
							<template v-if="['edit', 'create'].includes(type)">
								<v-edit-dialog large persistent save-text="guardar" cancel-text="cancelar"
									:return-value.sync="salesorder.discount">
									<v-tooltip right>
										<template v-slot:activator="{ on, attrs }">
											<span v-bind="attrs" v-on="on">
												{{
													`Descuento(${salesorder.discount}%):`
												}}
											</span>
										</template>
										<span>
											Modificar descuento
										</span>
									</v-tooltip>

									<template v-slot:input>
										<v-container fluid>
											<v-row class="pb-0">
												<v-col cols="12" class="pb-0">
													<v-text-field dense outlined hide-details type="number"
														label="Descuento" v-model="salesorder.discount
															" @change="
																min(
																	salesorder,
																	'discount',
																	'descuento',
																	0,
																	true
																),
																max(
																	salesorder,
																	'discount',
																	'descuento',
																	100,
																	true
																)
																"></v-text-field>
												</v-col>
											</v-row>
										</v-container>
									</template>
								</v-edit-dialog>
							</template>
							<template v-else>
								{{ `Descuento(${salesorder.discount}%):` }}
							</template>
						</template>
						<template v-else>
							{{ `Descuento(${salesorder.discount}%):` }}
						</template>
					</v-col>
					<v-col cols="5" class="pb-0 pt-1 d-flex justify-end">
						{{ discountAmount }}
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="7" class="pb-0 pt-1 d-flex justify-end font-weight-bold">
						IVA:
					</v-col>
					<v-col cols="5" class="pb-0 pt-1 d-flex justify-end">
						{{ ivaAmount }}
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="7" class="pb-0 pt-1 d-flex justify-end font-weight-bold">
						Total:
					</v-col>
					<v-col cols="5" class="pb-0 pt-1 d-flex justify-end">
						{{ total }}
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<v-row>
			<v-col v-if="type === 'create' || type === 'edit'" cols="12 mt-3" :class="[
				'd-flex',
				'justify-end',
				$vuetify.breakpoint.smAndDown
					? 'flex-column-reverse pt-4'
					: 'flex-row',
			]">
				<v-btn text color="primary" @click="cancel()" class="mr-2" :disabled="ui.sending">
					cancelar
				</v-btn>

				<template v-if="type === 'create'">
					<v-btn class="mb-2" color="primary" @click="store()" :loading="ui.sending"
						:disabled="!ui.forms.general" :block="$vuetify.breakpoint.smAndDown">
						Enviar
					</v-btn>
				</template>

				<template v-if="type === 'edit'">
					<v-btn class="mb-2" color="primary" @click="update()" :loading="ui.sending"
						:disabled="!ui.forms.general" :block="$vuetify.breakpoint.smAndDown">
						Actualizar
					</v-btn>
				</template>
			</v-col>
		</v-row>

		<template v-if="hasRol(1)">
			<!-- ShippingMethodCreateComponent -->
			<ShippingMethodCreate></ShippingMethodCreate>
		</template>

		<!-- Import Component -->
		<Import></Import>
	</div>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";

// VUEX
import { mapState } from "vuex";
import { mapGetters } from "vuex";

// Class
import Article from "@/clas/Article";
import SalesOrder from "@/clas/SalesOrder";

// Components
import Import from "@/components/PurchaceOrder/Import";
import AmountIputGroup from "@/components/AmountIputGroup";
import ShippingMethodCreate from "@/../../GeneralComponents/VUEX/ShippingMethodCreate";

export default {
	props: ["salesorder", "type", "geting"],

	components: { ShippingMethodCreate, AmountIputGroup, Import },

	data() {
		return {
			layout: {},

			endpoint: `${process.env.VUE_APP_API_SERVER}/auth/salesorder`,

			ui: {
				forms: {
					layout: true,
					others: true,
					general: true,
					addressInfo: true,
				},
				search: null,
				maxLengthNote: 750,
				action: "push",
				sending: false,
				articlesGeting: false,
				getingCustomers: false,
			},

			v: V,
		};
	},

	mounted() {
		EventBus.$on("InputError", (InputErrors) => {
			this.errorMessages = InputErrors;
		});

		EventBus.$on("SalesOrderCpturesAssign", (items) => {
			this.salesorder.articles = Object.assign([], []);

			items.forEach((item) => {
				let article = this.findArticleSelectedById(item.id);

				this.articlePush({ ...article, amount: item.amount });
			});

			EventBus.$emit("Snackbar", {
				text: `${items.length} artículos agregados.`,
				type: "success",
			});
		});

		this.$store.dispatch("getShippingMethods");

		// Redefinimos el endpoint segun el rol
		if (this.hasRol(6)) {
			this.endpoint = `${process.env.VUE_APP_API_SERVER}/auth/customer/purchaceorder`;
		}
	},

	methods: {
		headers() {
			if (this.hasRol(1)) {
				return [
					{
						text: "Codigo de artículo",
						value: "code",
						sortable: false,
					},
					{
						text: "Descripción",
						value: "description",
						sortable: false,
					},
					{ text: "Cantidad", value: "amount", sortable: true },
					{
						text: "Precio unitario para orden de venta",
						value: "price",
						sortable: false,
					},
					{
						text: "Descuento unitario para orden de venta",
						value: "discount",
						sortable: false,
					},
					{ text: "Importe", value: "importe", sortable: false },
					{ text: "Cajas", value: "box_capacity", sortable: false },
					{ text: "", value: "remove", sortable: false },
				];
			}

			return [
				{ text: "Codigo de artículo", value: "code", sortable: false },
				{ text: "Descripción", value: "description", sortable: false },
				{ text: "Cantidad", value: "amount", sortable: true },
				{ text: "Precio unitario", value: "price", sortable: false },
				// { text: "Descuento(%)", value: "discount" , sortable: false},
				{ text: "Importe", value: "importe", sortable: false },
				{ text: "Cajas", value: "box_capacity", sortable: false },
				{ text: "", value: "remove", sortable: false },
			];
		},

		async customerChanged() {
			if (this.salesorder.customer_id) {
				let customer = this.$store.state.customers.find(
					(customer) => customer.id === this.salesorder.customer_id
				);

				this.ui.articlesGeting = true;

				this.$store.commit("SET_ARTICLES", []);

				await this.$store.dispatch("getArticles", customer.id);

				this.salesorder.discount = customer.discount;

				this.save();

				this.ui.articlesGeting = false;
			}
		},

		articleAdd() {
			if (!this.$refs.layout.validate()) {
				return false;
			}

			if (!this.layout.id) {
				return false;
			}

			let article = this.findArticleSelectedById(this.layout.id);

			if (!article) {
				return alert(`Artículo no encontrado`);
			}

			if (this.getArticleInSalesOrderById(article.id)) {
				return alert(`Este artículo ya se encuentra agregado`);
			}

			this.articlePush({
				...article,
				amount: this.layout.amount,
				discount: this.layout.discount,
			});

			this.save();

			this.layout = Object.assign({}, {});

			EventBus.$emit("Snackbar", {
				text: "Artículo agregado.",
				type: "success",
			});

			this.$refs.layout.$children[0].focus();
		},

		articlePush(item) {
			let article = {
				id: item.id,
				code: item.code,
				price: item.price,
				weight: item.weight,
				amount: item.amount,
				discount: item.discount,
				description: item.description,
				box_capacity: item.box_capacity,
			};

			if (this.hasRol(1)) {
				article = {
					id: item.id,
					code: item.code,
					price: item.price,
					weight: item.weight,
					amount: item.amount,
					discount: item.discount,
					base_price: item.base_price,
					description: item.description,
					box_capacity: item.box_capacity,
					base_discount: item.base_discount,
					preferential_price: item.preferential_price,
					preferential_discount: item.preferential_discount,
				};
			}

			this.salesorder.articles.push(Object.assign({}, article));
		},

		findArticleSelectedById(article_id) {
			return this.getArticlesIndexed[article_id];
		},

		removeItem(item) {
			let indexOf = this.salesorder.articles.indexOf(item);

			if (
				confirm(`¿Quíere remover: ${item.code} - ${item.description}?`)
			) {
				this.salesorder.articles.splice(indexOf, 1);

				this.save();
			}
		},

		async store() {
			try {
				const valAddres = this.$refs.addressInfo.validate();
				const valGen = this.$refs.general.validate()
				const valSale = this.salesorder;
				if (valAddres != true || valGen != true) {
					return alert(`Existen campos obigatorios sin llenar.`);
				}
				if (valSale.articles.length == 0) {
					return alert(`La lista debe contener al menos una linea.`);
				}

				if (!confirm("¿Quíere realizar ahora?")) {
					return false;
				}

				if (this.hasRol(1)) {
					if (!valGen) {
						return false;
					}
				}

				if (valSale.note) {
					if (valSale.note.length > this.ui.maxLengthNote) {
						return alert(
							`El campo "nota" exede el número de caracteres permitidos (${this.ui.maxLengthNote}).`
						);
					}
				}

				this.ui.sending = true;

				EventBus.$emit("SalesOrderSending", true);

				let response = await axios.post(
					this.endpoint,
					this.makePayload(),
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				this.$emit("created", response.data.data);

				localStorage.removeItem("salesorder");
			} catch (error) {
				try {
					switch (error.response.status) {
						case 401:
							this.$store.dispatch("setTokenRefreshDialog", true);
							break;
						default:
							EventBus.$emit("Error", {
								error: error,
								errorsShow: true,
							});
							break;
					}
				} catch (e) {
					EventBus.$emit("Error", {
						error: error,
						errorsShow: true,
					});
				}
			} finally {
				this.ui.sending = false;

				EventBus.$emit("SalesOrderSending", false);
			}
		},

		custommerCreate() {
			EventBus.$emit("CustommerCreate");
		},

		shippingMethodCreate() {
			EventBus.$emit("ShippingMethodCreate");
		},

		async update() {
			try {
				if (this.salesorder.articles.length == 0) {
					return alert(`La lista debe contener almenos una linea`);
				}

				if (this.salesorder.note) {
					if (this.salesorder.note.length > this.ui.maxLengthNote) {
						return alert(
							`El campo "nota" exede el número de caracteres permitidos (${this.ui.maxLengthNote}).`
						);
					}
				}

				if (!confirm("¿Quíere realizar la actualización ahora?")) {
					return false;
				}

				EventBus.$emit("SalesOrderSending", true);

				this.ui.sending = true;

				let response = await axios.put(
					`${this.endpoint}/${this.salesorder.id}`,
					this.makePayload(),
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				this.scrollTop();

				EventBus.$emit("Snackbar", {
					text: "Actualizado correctamente.",
					type: "success",
				});

				this.$emit("updated");

				localStorage.removeItem("salesorder");
			} catch (error) {
				try {
					switch (error.response.status) {
						case 401:
							this.$store.dispatch("setTokenRefreshDialog", true);
							break;
						default:
							EventBus.$emit("Error", {
								error: error,
								errorsShow: true,
							});
							break;
					}
				} catch (e) {
					EventBus.$emit("Error", {
						error: error,
						alertShow: true,
					});
				}
			} finally {
				this.ui.sending = false;

				EventBus.$emit("SalesOrderSending", false);
			}
		},

		cancel() {
			this.$emit("cancel");

			this.scrollTop();
		},

		hasRol(rol_id_required) {
			return this.acount_roles_ids.includes(rol_id_required);
		},

		save() {
			localStorage.setItem("salesorder", JSON.stringify(this.salesorder));
		},

		scrollTop() {
			setTimeout(() => {
				window.scrollTo({ top: 0, behavior: "smooth" });
			}, 300);
		},

		price(article) {
			let a = new Article(article);

			return a.price();
		},

		hasDiscount(article) {
			let a = new Article(article);

			return a.hasDiscount();
		},

		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		min(item, property, alias, min, showAlert) {
			if (item[property] < min) {
				if (showAlert) {
					alert(
						`El tamaño de la propiedad "${alias}" debe ser de al menos ${min}.`
					);
				}

				item[property] = min;
			}
		},

		max(item, property, alias, max, showAlert) {
			if (!item[property]) {
				item[property] = max;
			}

			if (item[property] > max) {
				if (showAlert) {
					alert(
						`El tamaño de la propiedad "${alias}" debe ser menor a ${max}.`
					);
				}

				item[property] = max;
			}
		},

		getArticleInSalesOrderById(id) {
			return this.salesorder.articles.find(
				(article) => article.id === id
			);
		},

		getIndexOf(item) {
			let article = this.getArticleInSalesOrderById(item.id);

			if (article) {
				return this.salesorder.articles.indexOf(article);

				// return this.salesorder.articles.length - indexOf;

				return indexOf;
			}

			return null;
		},

		getItemAmount(item) {
			let a = new Article(item);

			return (a.price() * parseInt(item.amount)).toFixed(2);
		},

		getItemBoxCapacity(item) {
			if (this.getBoxCapacity(item) > 1) {
				let box_capacity = (
					parseInt(item.amount) / parseInt(item.box_capacity)
				).toFixed(0);

				return `${box_capacity} caja(s) con ${item.box_capacity} piezas`;
			}

			return "NA";
		},

		getBoxCapacity(article) {
			if (article) {
				if (article.box_capacity) {
					if (article.box_capacity > 1) {
						return article.box_capacity;
					}
				}
			}

			return 1;
		},

		makePayload() {
			let salesorder = this.salesorder;

			if (this.hasRol(1)) {
				return {
					...salesorder,
					articles: salesorder.articles.map((article) => {
						return {
							id: article.id,
							price: article.price,
							amount: article.amount,
							discount: article.discount,
							base_price: article.base_price,
							base_discount: article.base_discount,
							preferential_price: article.preferential_price,
							preferential_discount:
								article.preferential_discount,
						};
					}),

					customer: undefined,
					customer_id: salesorder.customer_id,
				};
			}

			return {
				shipping_method_id: salesorder.shipping_method_id,
				note: salesorder.note,
				articles: salesorder.articles.map((article) => {
					return {
						id: article.id,
						amount: article.amount,
					};
				}),
			};
		},
	},

	computed: {
		...mapState({
			shipping_methods: "shipping_methods",
			getingShippingMethods: "ui.getingShippingMethods",
		}),

		...mapGetters({
			getArticles: "getArticles",

			acount_roles_ids: "getAcountRolesIds",

			getArticlesIndexed: "getArticlesIndexed",
		}),

		Weight() {
			let salesOrder = new SalesOrder(this.salesorder);

			return `${salesOrder.weight()} Kg`;
		},

		subtotal() {
			const s = new SalesOrder(this.salesorder);

			return this.priceFormat(s.subTotal());
		},

		discountAmount() {
			const s = new SalesOrder({
				...this.salesorder,
				discount: this.salesorder.discount,
			});

			s.setDiscount(0);

			return this.priceFormat(s.discountAmount());
		},

		ivaAmount() {
			const s = new SalesOrder({
				...this.salesorder,
				discount: this.salesorder.discount,
			});

			return this.priceFormat(s.ivaAmount());
		},

		total() {
			const s = new SalesOrder({
				...this.salesorder,
				discount: this.salesorder.discount,
			});

			return this.priceFormat(s.total());
		},

		ShippingMethods() {
			return this.shipping_methods.map((item) => {
				return { text: item.name, value: item.id };
			});
		},

		Customers() {
			return this.$store.state.customers.map((item) => {
				return {
					text: `${item.folio} - ${item.name}`,
					value: item.id,
				};
			});
		},

		Articles() {
			return this.getArticles.map((item) => {
				return {
					text: `${item.code} - ${item.description}`,
					value: {
						id: item.id,
						discount: item.discount,
						amount: this.getBoxCapacity(item),
						box_capacity: this.getBoxCapacity(item),
					},
				};
			});
		},

		// Items() {
		// 	return this.salesorder.articles.reverse();
		// },

		ItemNewBoxCapacity() {
			return this.getBoxCapacity(this.layout);
		},
	},
};
</script>

<style lang="css" scoped></style>
